<template>
  <SectionWithAnchor :anchorId="AnchorLinks.SellWithAgent">
    <div class="row">
      <div class="col-md-10 col-lg-8" :class="$style.sellingPortalContainer">
        <div :class="$style.content">
          <h2>{{ $t('localLanding.sellingPortal.title') }}</h2>
          <p>{{ $t('localLanding.sellingPortal.contentText') }}</p>
        </div>
        <div :class="$style.portalWrapper">
          <SellingPortal
            v-for="item in sellingPortalData"
            :key="item.id"
            :portalDataObject="item"
          />
        </div>
      </div>
    </div>
  </SectionWithAnchor>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import SectionWithAnchor from '@/components/common/SectionWithAnchor/SectionWithAnchor.vue';
import SellingPortal, {
  PortalDataObject,
} from '@/components/local-landing-page/SellingPortal/SellingPortal.vue';
import { AnchorLinks, SellingTypes } from '@/types';

// Composables
const { t } = useI18n();

// Computed properties
const sellingPortalData = computed((): Array<PortalDataObject> => {
  return [
    {
      id: SellingTypes.DIY,
      title: t('localLanding.sellingPortal.headingDiy'),
      advantages: [
        {
          heading: t('localLanding.sellingPortal.optionHeadingDiy1'),
          contentText: t('localLanding.sellingPortal.optionContentDiy1'),
        },
        {
          heading: t('localLanding.sellingPortal.optionHeadingDiy2'),
          contentText: t('localLanding.sellingPortal.optionContentDiy2'),
        },
        {
          heading: t('localLanding.sellingPortal.optionHeadingDiy3'),
          contentText: t('localLanding.sellingPortal.optionContentDiy3'),
        },
        {
          heading: t('localLanding.sellingPortal.optionHeadingDiy4'),
          contentText: t('localLanding.sellingPortal.optionContentDiy4'),
        },
      ],
      buttonText: t('localLanding.sellingPortal.buttonDiy'),
    },
    {
      id: SellingTypes.AGENT,
      title: t('localLanding.sellingPortal.headingAgent'),
      advantages: [
        {
          heading: t('localLanding.sellingPortal.optionHeadingAgent1'),
          contentText: t('localLanding.sellingPortal.optionContentAgent1'),
        },
        {
          heading: t('localLanding.sellingPortal.optionHeadingAgent2'),
          contentText: t('localLanding.sellingPortal.optionContentAgent2'),
        },
        {
          heading: t('localLanding.sellingPortal.optionHeadingAgent3'),
          contentText: t('localLanding.sellingPortal.optionContentAgent3'),
        },
        {
          heading: t('localLanding.sellingPortal.optionHeadingAgent4'),
          contentText: t('localLanding.sellingPortal.optionContentAgent4'),
        },
        {
          heading: t('localLanding.sellingPortal.optionHeadingAgent5'),
          contentText: t('localLanding.sellingPortal.optionContentAgent5'),
        },
      ],
      buttonText: t('localLanding.sellingPortal.buttonAgent'),
    },
  ];
});
</script>

<style module lang="scss">
@use '@/assets/variables' as *;

.sellingPortalContainer {
  display: flex;
  flex-direction: column;
  gap: $space-250;
  margin-right: auto;
  margin-left: auto;

  .content {
    color: $color-grey-100;

    h2 {
      @include vertical-margin(0, $space-75);
      @include heading-2;
    }

    p {
      @include vertical-margin;
      @include body-1;
    }
  }

  .portalWrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;

    @include grid-media-query(sm) {
      flex-direction: row;
    }
  }
}
</style>
